import type { JobArt } from "./typen";

/* ══════════════════════════════════════════════════════════════════
   Die Läufe, die der Verlauf unter Einstellungen › Jobs darstellt.

   **Seit dem 03.10.2026 vollständig erzwungen** (Playbook M-30, M-29,
   M-36). Die Liste filtert, was die Maske zeigt — und war eine Menge
   von Hand: `webhook` fehlte, dann `lex_beleg`, zuletzt `meldungen` und
   `ressourcenstand`. Jedes Mal sagte die Pille „Noch kein Lauf
   verzeichnet", während in der Datenbank Läufe standen. Ein Filter, der
   still wegwirft, ist schlimmer als gar keiner.

   Jetzt ist es ein `Record` über `JobArt`: Fehlt eine Art des Typs,
   baut die Anwendung nicht. Und `apps/web/test/jobarten.test.ts` hält
   den Typ gegen `JOBARTEN` der API (`dienste/lauf.ts`) — dieselbe Liste,
   die als CHECK an `job_run` steht.
   ══════════════════════════════════════════════════════════════════ */

const ALLE: Record<JobArt, true> = {
  lex_kunden: true,
  lex_kunden_schieben: true,
  lex_artikel: true,
  lex_artikel_schieben: true,
  lex_beleg: true,
  lex_zahlungsstand: true,
  webhook: true,
  abrechnung: true,
  erinnerung: true,
  optionsverfall: true,
  ressourcenstand: true,
  meldungen: true,
  archiv: true,
  archiv_pruefung: true,
  lex_verbindung: true,
};

export const JOBARTEN_WEB = Object.keys(ALLE) as JobArt[];

export const istJobArt = (art: string): art is JobArt =>
  Object.prototype.hasOwnProperty.call(ALLE, art);
